import type { ScoreBarRange } from '@ksyos/design-system/dist/components/score-bar';
import { thresholdOsasHsdqQuesionnaire } from '@common/constants';
import { QuestionnaireName } from '@common/enums';
import { getEssResultMessage } from '@common/utils/getEssResultMessage';
import { getHsdqResultMessage } from '@common/utils/getHsdqResultMessage';

interface IquestionnaireObject {
    getMessage: (score: number) => string;
    maxValue: number;
    minValue: number;
    range: ScoreBarRange[];
    rangeStops: number[];
}

export const questionnaireProperties: { [keys: string]: IquestionnaireObject } = {
    [QuestionnaireName.osasEss]: {
        getMessage: getEssResultMessage,
        maxValue: 24,
        minValue: 0,
        range: ['none', 'moderate', 'extreme'],
        rangeStops: [42, 62],
    },
    [QuestionnaireName.osasHsdq]: {
        getMessage: getHsdqResultMessage,
        maxValue: 5,
        minValue: 1,
        range: ['none', 'extreme'],
        rangeStops: [(thresholdOsasHsdqQuesionnaire * 100) / 5],
    },
};
